import type { UseMutationResult } from '@tanstack/react-query';
import { useMutation } from '@tanstack/react-query';

import type { CallbackRequest } from '../../data-contract/chat';
import { useApplicationFetchers } from '../../fetchers/use-application-fetchers';

type Variables = {
    readonly blockId: string;
    readonly eventId: string;
    readonly payload: CallbackRequest;
};

export const useSubmitChatInteractionCallback = (): UseMutationResult<unknown, Error, Variables> => {
    const { submitChatInteractionCallback } = useApplicationFetchers();

    return useMutation({
        mutationFn: async (variables) => {
            const result = await submitChatInteractionCallback(variables);

            if (result.isErr === true) {
                throw result.error;
            }

            return result.value;
        },
    });
};
